import { Pipe, PipeTransform } from '@angular/core';

import { toCSSUrl } from './to-css-url';

/**
 * Angular pipe that wraps an image URL with CSS `url()` syntax.
 *
 * This pipe is useful for formatting image URLs so they can be directly used
 * in CSS styles, such as for setting background images.
 *
 * @pipe
 * @name ToCssUrlPipe
 * @usageNotes
 * This pipe can be used in Angular templates to apply CSS-compatible
 * `url()` syntax to image URLs:
 *
 * ```html
 * <div [style.backgroundImage]="imageUrl | msToCssUrl"></div>
 * ```
 *
 * @example
 * // In a template:
 * <div [style.backgroundImage]="'https://example.com/image.jpg' | msToCssUrl"></div>
 * will be <div [style.backgroundImage]="'url(https://example.com/image.jpg)'"></div>
 *
 */

@Pipe({ name: 'msToCssUrl', standalone: true })
export class ToCssUrlPipe implements PipeTransform {
    transform(value: string): string {
        return toCSSUrl(value);
    }
}
